import React from "react";
import { Chip, Tooltip, Typography, Box } from "@mui/material";
import { PolicyOrAccount } from "../../../interfaces/DTO/mislaka_xml_models";
import { MimshakService } from "../../../services/mimshakService";
import { formatCurrency } from "../../../utils/namesFormater";

interface LoanChipProps {
  policies: PolicyOrAccount[];
}

export const LoanChip: React.FC<LoanChipProps> = ({ policies }) => {
  // קבלת כל ההלוואות
  const loans = MimshakService.getAllLoans(policies);

  // אם אין הלוואות, לא מציגים כלום
  if (loans.length === 0) {
    return null;
  }

  // יצירת תוכן ה-Tooltip
  const tooltipContent = (
    <Box sx={{ p: 1 }} dir="rtl">
      {loans.map((loan, index) => (
        <Typography
          key={index}
          variant="body2"
          sx={{ whiteSpace: "nowrap", direction: "rtl", textAlign: "right" }}
        >
          {`הלוואה ${index + 1}:${formatCurrency(loan.loan_amount)}`}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <Chip
        label="הלוואה"
       
        sx={{ cursor: "pointer", fontSize: "0.875rem",backgroundColor:"blueviolet",color:"white" }}
      />
    </Tooltip>
  );
};
